
import React, { useEffect, useState } from "react";
import { Button, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import { Field, Formik } from "formik";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import reset from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";
import CoveredEntity from "components/CoveredEntity";
import useContextService from "hooks/useContextService";
import Accmulator from "components/Accmulator";
import ReactSelect from 'react-select';
import useAxios from "hooks/useAxios";
import { Option } from 'components/Options';
import { some } from "lodash";

let coveredEntitiesData = [];
let accumulationData = [];
let coveredEntityError = "Covered Entity is a required field";
let accumulationError = "Accumulator is a required field";


const SearchContainerAutoMapping = (props) => {
    const {
        toggleSide,
        collapseSider,
        orgId,
        onSearch,
        resetData,
        key,
        setLoading,
        reset
    } = props;
    const {
        states: { crosswalkAutomapping },
        setStates,
        resetStates,
    } = useContextService();
    const API = useAxios();
    const [hasACCSelected, setACCSelected] = useState(true);
    const [hasCESelected, setCESelected] = useState(true);
    const [chargeAutoFlag,setChargeAutoFlag] = useState(false);
   // const [loading, setLoading] = useState(false);
    const [isSubmited, serIsSubmitted] = useState(false);
    const [selectedCEOption, setCEOptionSelected] = useState({
        optionCESelected: "-1",
    });
    const [selectedACCOption, setOptionACCSelected] = useState({
        optionACCSelected: "-1",
    });
    const updateStates = (crosswalkAutomapping) => {
        setStates("crosswalkAutomapping", crosswalkAutomapping);
    };
    const { automappingsearch, searchTerms,accumulations } = crosswalkAutomapping;
    let {
        coveredEntityIDs,
        accumulationIDs,

    } = searchTerms;
    useEffect(() => {
        setCESelected(true);
        setACCSelected(true);
        coveredEntitiesData = [];
        accumulationData = [];
        crosswalkAutomapping.searchTerms.coveredEntityIDs = [];
        crosswalkAutomapping.searchTerms.accumulationIDs = {}
        crosswalkAutomapping.accumulations = [];
        updateStates(crosswalkAutomapping);
        setCEOptionSelected({ optionCESelected: '-1' });
        setOptionACCSelected({ optionACCSelected: '-1' });
        serIsSubmitted(false);
        setChargeAutoFlag(false);
        fetchCoveredEntities();
    }, [orgId,key, reset]);

    const fetchCoveredEntities = async () => {
        debugger;
        //let { organizationID } = orgId;
        if (typeof orgId !== "undefined" && orgId !== null) {
            coveredEntitiesData = [];
            crosswalkAutomapping.searchTerms.coveredEntityIDs = [];
            updateStates(crosswalkAutomapping);

            let selectedOrgId = orgId.organizationID;

            setLoading(true);
            try {
                const { data } = await API.get(`SBConfig/coveredentity/list/${selectedOrgId}`, {
                    hasDefaultURL: true,
                });
              
                if (data) {
                    for (var x in data) {
                        coveredEntitiesData.push({ "value": data[x].coveredEntityID, "label": data[x].coveredEntityName });
                    }
                    crosswalkAutomapping.coveredEntities = data;

                    if (coveredEntitiesData.length == 1) {
                        var ceData = [];
                        ceData.push(coveredEntitiesData[0])
                        crosswalkAutomapping.searchTerms.coveredEntityIDs = ceData;
                        window.selectedCoveredEntittyId = ceData;
                    }
                    if (window.selectedCoveredEntittyId.length > 0) {
                        crosswalkAutomapping.searchTerms.coveredEntityIDs = window.selectedCoveredEntittyId;
                    }
                    updateStates(crosswalkAutomapping);
                    if (crosswalkAutomapping.searchTerms.coveredEntityIDs) {

                        var ceSelected = [];
                        ceSelected.optionCESelected = [];
                        for (var x in crosswalkAutomapping.searchTerms
                            .coveredEntityIDs) {
                            ceSelected.optionCESelected.push(
                                crosswalkAutomapping.searchTerms.coveredEntityIDs[x]
                            );
                        }
                        setCEOptionSelected(ceSelected);
                        let ceIds = crosswalkAutomapping.searchTerms.coveredEntityIDs.map(item => item["value"]);
                        fetchAccumulatorName(ceIds);
                    }
                    setLoading(false);
                }
                  setLoading(false);
            }
            catch (err) {
                setLoading(false);
            }
        }

    };
    const handleCoverdEntityChange = (selectedces, setFieldValue, entity) => {
        let selected = [selectedces == null ? [] : selectedces]

        if (selected) {
            window.selectedCoveredEntittyId = selected;
            window.selectedAccumulatorId = [];
            accumulationData = [];
            // setSelectedNdc('');
            crosswalkAutomapping.searchTerms.accumulationIDs = {};
            setCESelected(true);
            setCEOptionSelected({
                optionCESelected: selectedces
            });
            let val = selected.value;
            crosswalkAutomapping.coveredEntities = selected;
            // setFieldValue('coveredEntityIDs', selected);
            crosswalkAutomapping.searchTerms.coveredEntityIDs = selected;
            if (Array.isArray(crosswalkAutomapping.searchTerms.coveredEntityIDs)) {
                accumulationIDs = {};
                crosswalkAutomapping.searchTerms.accumulationIDs = {};
            }
            let ceIds = crosswalkAutomapping.searchTerms.coveredEntityIDs.map(item => item["value"]);
            crosswalkAutomapping.searchTerms.coveredEntityIDs = ceIds;
            updateStates(crosswalkAutomapping);
            fetchAccumulatorName(ceIds);
            setOptionACCSelected({ optionACCSelected: '-1' });
        }
        else {
            // setFieldValue('coveredEntityIDs', {});
            accumulationData = [];
            crosswalkAutomapping.coveredEntities = [];
            crosswalkAutomapping.searchTerms.coveredEntityIDs = {};
            crosswalkAutomapping.searchTerms.accumulationIDs = {};
            setCESelected(false);
            setACCSelected(false);
        }
        updateStates(crosswalkAutomapping);
    };
    const fetchAccumulatorName = async (coveredEntityIDs) => {

        if (coveredEntityIDs !== undefined && coveredEntityIDs.length > 0) {
            try {
                accumulationData = [];
                const payload = [];
                payload.AccumulatorEntityList = [coveredEntityIDs[0]];
                let AccumulatorEntityList = [payload.AccumulatorEntityList]
                const result = await API.get(`SBConfig/coveredentity/acclist/${AccumulatorEntityList}`,
                    {
                        hasDefaultURL: true,
                    }
                );
                if (result) {
                    let accumulator = []
                    accumulator = result.data;
                    for (var x in accumulator) {
                        accumulationData.push({ "value": accumulator[x].accumulatorID, "label": accumulator[x].ceName });
                    }

                    if (accumulationData.length == 1) {
                        handleAccumulatorname(accumulationData[0],result.data);

                    }
                    //    else if (window.selectedAccumulatorId.length > 0) {
                    //     crosswalkAutomapping.searchTerms.accumulationIDs =
                    //       window.selectedAccumulatorId;
                    //       handleAccumulatorname(window.selectedAccumulatorId[0]);
                    //   }

                    crosswalkAutomapping.accumulations = result.data;
                    updateStates(crosswalkAutomapping);
                    // if (accumulationIDs.length > 0) {
                    //     var accumulatorSelected = {};
                    //     accumulatorSelected.optionACCSelected = [];
                    //     for (var x in accumulationIDs) {
                    //         accumulatorSelected.optionACCSelected.push(accumulationIDs[x]);
                    //     }
                    //     setOptionACCSelected({ accumulatorSelected});
                    // }
                }
            } catch (error) {
                console.log(error.message);
            }
        }
    };
    const handleAccumulatorname = (selectedacs,accumulationsall ) => {

        let selected = [selectedacs == null ? [] : selectedacs]
        window.selectedAccumulatorId = selected;
        if (selected) {
            setACCSelected(true);
            setOptionACCSelected({
                optionACCSelected: selected
            })
            debugger;
            const allData = (accumulationsall.length == 0 || accumulationsall == undefined)? accumulations : accumulationsall;
            const accrecord = allData.find(item => item.accumulatorID === selected[0].value);
            if (accrecord?.chargeAutomappingFlag == "N") {
                setChargeAutoFlag(true)
            }
            else{
                 setChargeAutoFlag(false)
            }
           
            //   let val = selected.value;
            //   setFieldValue('accumulatorID', val);
            //   setFieldValue('accumulationIDs', selected);
            crosswalkAutomapping.searchTerms.accumulationIDs = selected;
            handleSubmit();
        }
        else {
            setACCSelected(true);
            //   setFieldValue('accumulationIDs', {});
            accumulationData = [];
            crosswalkAutomapping.coveredEntities = [];
            crosswalkAutomapping.searchTerms.accumulationIDs = {};
            crosswalkAutomapping.searchTerms.coveredEntityIDs = {};
            setCESelected(false);
        }
        updateStates(crosswalkAutomapping);
    };

    const handleSubmit = async () => {
        debugger;
        let values = {};
        serIsSubmitted(true);
        // const { setSubmitting } = actions;
        let acIDs = [];
        let ceIDs = [];
        for (var x in searchTerms.accumulationIDs) {
            var rw = searchTerms.accumulationIDs[x];
            acIDs.push(rw.value);
        }
        for (var x in searchTerms.coveredEntityIDs) {
            var rw = searchTerms.coveredEntityIDs[x];
            ceIDs.push(rw.value);

        }

        if (ceIDs.length > 0 && acIDs.length == 0) {
            setACCSelected(false);
            return true;
        }
        if (ceIDs.length == 0 && acIDs.length == 0) {
            setCESelected(false);
            setACCSelected(false);
            return true;
        }
        if (acIDs > [0]) values.accumulationIDs = acIDs[0];
        crosswalkAutomapping.automappingsearch.currentPage = 1;
        crosswalkAutomapping.automappingsearch.filters = [];
        updateStates(crosswalkAutomapping);
        await onSearch(values);
        // setSubmitting(false);
    };
        const handleReset =async () => {
        serIsSubmitted(false);
        setCESelected(true);
        setACCSelected(true);
        accumulationData=[];
        setChargeAutoFlag(false);
        window.selectedCoveredEntittyId = "";
        window.selectedAccumulatorId = "";
        setCEOptionSelected({ optionCESelected: "-1" });
        setOptionACCSelected({ optionACCSelected: "-1" });
        crosswalkAutomapping.searchTerms.coveredEntityIDs = {};
        crosswalkAutomapping.searchTerms.mappingStatus = "all";
        crosswalkAutomapping.searchTerms.accumulationIDs = {};
        updateStates(crosswalkAutomapping);
        //resetStates("crosswalkAutomapping");
    await resetData();
    }
    return (
        <div>
            {/* {Loading&&<Loader opacity={0.01}color='black'/>}  */}
            <Formik
                initialValues={searchTerms}
                onSubmit={handleSubmit}
                // validationSchema={validationSchema}
                enableReinitialize={true}
                children={(props) => {
                    const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                    return (
                      <div hidden={collapseSider}>
                        <div>
                          <Row sm={5} className="d-flex" style={{}}>
                            <Col md={3} lg={3} sm={6} xs={6}>
                              {" "}
                              <FormGroup>
                                <Label for="coveredentity">
                                  Covered Entity
                                </Label>

                                <ReactSelect
                                  name="coveredentity"
                                  id="coveredentity"
                                  options={coveredEntitiesData}
                                  // isMulti
                                  closeMenuOnSelect={true}
                                  hideSelectedOptions={false}
                                  optionSelected={true}
                                  // isClearable={true}
                                  isSearchable="true"
                                  onChange={(value, cp) =>
                                    handleCoverdEntityChange(
                                      value,
                                      setFieldValue,
                                      cp
                                    )
                                  }
                                  value={selectedCEOption.optionCESelected}
                                  className="claim_info required"
                                  components={{
                                    Option,
                                  }}
                                  maxMenuHeight={220}
                                  styles={{
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 99,
                                    }),
                                    option: (provided) => ({
                                      ...provided,
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }),
                                  }}
                                />
                                {!hasCESelected ? (
                                  <div className="text-danger f-12 position-absolute">
                                    {coveredEntityError}
                                  </div>
                                ) : null}
                              </FormGroup>
                            </Col>
                            <Col md={3} lg={3} sm={6} xs={6}>
                              {" "}
                              <FormGroup>
                                <Label for="accumulator">Accumulator</Label>
                                <ReactSelect
                                  name="accumulatorID"
                                  id="accumulationIDs"
                                  options={accumulationData}
                                  // isMulti
                                  closeMenuOnSelect={true}
                                  hideSelectedOptions={false}
                                  optionSelected={true}
                                  isDisabled={accumulationData.length == 1}
                                  //isClearable={true}
                                  components={{
                                    Option,
                                  }}
                                  value={selectedACCOption.optionACCSelected}
                                  isSearchable="true"
                                  onChange={(value, ac) =>
                                    handleAccumulatorname(
                                      value,
                                      setFieldValue,
                                      ac
                                    )
                                  }
                                  className="claim_info required"
                                  maxMenuHeight={220}
                                  styles={{
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 99,
                                    }),
                                    option: (provided) => ({
                                      ...provided,
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }),
                                  }}
                                />
                                {(!hasACCSelected && isSubmited) ||
                                (hasCESelected &&
                                  isSubmited &&
                                  selectedACCOption.optionACCSelected ==
                                    "-1") ? (
                                  <div className="text-danger f-12 position-absolute">
                                    {accumulationError}
                                  </div>
                                ) : null}
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                        <div hidden={""}>
                          <Row>
                            {chargeAutoFlag ? (
                              <div
                                className="text-danger f-16"
                                style={{ fontWeight: "bold", paddingLeft: 207 }}
                              >
                                🚨 Editing is unavailable as the Accumulator
                                Level Automapping configuration is disabled. 🚨
                              </div>
                            ) : null}
                          </Row>
                          <Row
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <Col md="auto" className="">
                              <Label>{""}</Label>
                              <Button
                                color="primary"
                                className="search"
                                onClick={handleSubmit}
                              >
                                <span className="right_5">
                                  <img src={search} alt="" />
                                </span>{" "}
                                Search
                              </Button>
                              <Button
                                color="primary"
                                className="reset"
                                onClick={handleReset}
                              >
                                <span className="right_5">
                                  <img src={reset} alt="" />
                                </span>{" "}
                                Reset
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    );
                }}></Formik>
        </div>
    )

}

export default SearchContainerAutoMapping